module.exports = __webpack_public_path__ + "static/media/2-3-2_OPP_Matt_01.26a90927.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-3-2_OPP_Matt_01.jpg
// module id = 1721
// module chunks = 0